export default {
  'dialog.cancel': 'Cancel',
  'dialog.close': 'Close',

  // Confirmation dialog
  'confirmation-dialog.title': 'Are you sure?',
  'confirmation-dialog.confirm': 'Confirm',
};
